import React from 'react';

import { shortenName, getInitials } from '@/utils/helpers';
import { BlockIcon } from '@webmotors/storybook.pf';

import { VehicleInformations, BackButton, UserContact, BlockSection } from './components';
import { useHeaderLogic } from './header.hook';
import { HEADER_STRINGS } from './utils/header.constants';

import * as S from './header.styles';

const Header = React.memo(() => {
	const {
		isDesktop,
		isBlocked,
		isShowUserTag,
		isSellingTab,
		isSpam,
		showBlockedLabel,
		name,
		userTag,
		actualLead,
	} = useHeaderLogic();

	return (
		<>
			<S.Header data-qa="chat-header">
				<S.Wrapper>
					{!isDesktop && <BackButton />}
					<S.UserImage>{getInitials(name || undefined)}</S.UserImage>
					<S.UserInfo>
						<div>
							<S.Name>
								{shortenName(name || '')}
								{isShowUserTag && ` (${userTag})`}
							</S.Name>
							{showBlockedLabel && (
								<S.BlockedLabel data-testid="blocked-user-label" data-qa="blocked-user-label">
									<BlockIcon size={14} />
									{HEADER_STRINGS.BLOCKED_LABEL}
								</S.BlockedLabel>
							)}
						</div>
						{!isBlocked && <UserContact />}
					</S.UserInfo>

					{isSellingTab && !isSpam && <BlockSection />}
				</S.Wrapper>
			</S.Header>

			<VehicleInformations lead={actualLead} />
		</>
	);
});

Header.displayName = 'Header';
export { Header };
